import React from 'react';
import './DashboardType11Arka.scss';
import DashboardArkaProgrammer from "./DashboardArkaProgrammer";
import DashboardArkaManager from "./DashboardArkaManager";

const DashboardType11Arka = ({dashboardComponentData , setRefreshData , refreshData}) => {

  try {
    return (
      <>
        {dashboardComponentData?.userType === "programmer" ?
          <DashboardArkaProgrammer data={dashboardComponentData} setRefreshData={setRefreshData} refreshData={refreshData}/> :
          dashboardComponentData?.userType === "manager" ?
            <DashboardArkaManager data={dashboardComponentData}/> :
            <>userType not found ..!</>
        }
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default DashboardType11Arka;